export default __webpack_public_path__ + "static/20-4f6055f42ddc91c504ddf6a1d443670e.webp";